<h1>Albion Online Item Power Price Checker</h1>
@if (selectedItem && selectedItem.localizedName) {
  <h2>{{ selectedItem.localizedName }}</h2>
} @else {
  <h2><br /></h2>
}
<!-- MARK: TUTORIAL -->
<div style="margin: 10px 0px">
  <mat-accordion>
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title> Tutorial </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <div style="margin-bottom: 10px">
        <p>
          This tool helps you select the most cost-effective gear within a specified Item Power (IP) range. It's useful when deciding between options like a 6.0
          masterpiece or a 4.3 normal item.
        </p>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
@if (shopCategories && items && !isLoading) {
  <div class="flex-container-column">
    <div class="form-container">
      <app-item-selector
        class="form-container-inline"
        [shopCategories]="shopCategories"
        [items]="items"
        [showItemSelector]="true"
        [(selectedCategory)]="selectedCategory"
        [(selectedSubCategory)]="selectedSubCategory"
        [(selectedTier)]="selectedTier"
        [(selectedItem)]="selectedItem"
      >
      </app-item-selector>
      <button
        class="form-item-button"
        style="align-self: auto"
        mat-mini-fab
        (click)="refreshPrices()"
        [disabled]="(!(this.prices$ | async) && !(this.histories$ | async)) || disableRefresh"
        color="primary"
        aria-label="Clear All Button"
        matTooltip="Refresh Prices"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <mat-form-field class="form-item-medium">
        <mat-label>Mastery Bonus (found ingame)</mat-label>
        <input matInput [(ngModel)]="masteryBonus" type="number" step="10" (change)="selectedItem = selectedItem" placeholder="Your mastery bonus" />
        <mat-hint style="font-size: x-small">Mouse Over Item Power</mat-hint>
      </mat-form-field>
      <mat-form-field class="form-item-medium">
        <mat-label>Item Power Group Range</mat-label>
        <input matInput [(ngModel)]="groupRange" type="number" step="10" (change)="selectedItem = selectedItem" placeholder="Range to split the itemp power" />
      </mat-form-field>
    </div>
    <div class="flex-container-row"></div>
    <br />
    <app-locations-legend></app-locations-legend>
    <br />
    <mat-accordion>
      @for (group of groupedItemsArray; track group) {
        <mat-expansion-panel #panel hideToggle class="panel-background">
          <mat-expansion-panel-header>
            <mat-panel-title class="font-small">{{ group.key + ' - ' + (group.key + groupRange - 1) }} </mat-panel-title>
            <mat-panel-description class="font-small">
              @if (panel.expanded) {
                <div>
                  @if (getCheapestItem(group.value).cheapestPrice) {
                    Cheapest: {{ getCheapestItem(group.value).item.localizedName }}[{{ getCheapestItem(group.value).quality.name }}] for
                    {{ getCheapestItem(group.value).cheapestPrice?.sellPriceMin | number: '1.0-0' }} in
                    {{ getCheapestItem(group.value).cheapestPrice?.city?.displayName }}
                  } @else {
                    No prices avaliable for this group
                  }
                </div>
              } @else {
                @if (getCheapestItem(group.value).cheapestPrice) {
                  <div>
                    $ {{ getCheapestItem(group.value).cheapestPrice?.sellPriceMin | number: '1.0-0' }} [{{
                      getCheapestItem(group.value).cheapestPrice?.city?.displayName
                    }}]
                  </div>
                } @else {
                  No prices avaliable for this group
                }
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="price-card-container">
            @if (panel.expanded) {
              @for (item of group.value; track item) {
                <div>
                  <app-item-price-card
                    [item]="item.item"
                    [prices]="item.citiesPrices"
                    [imageUrl]="getItemImageUrl(item.item)"
                    [priceType]="selectedPriceType"
                    [footerText]="formatFooterText(item)"
                    [showChart]="false"
                  />
                </div>
              }
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
} @else {
  <mat-spinner></mat-spinner>
}
